import { useLang } from "../../i18n";
import { Reveal, SectionHead } from "./Section";

const FORMAT_IMGS = ["/assets/format-eau.jpg", "/assets/format-2925.jpg", "/assets/format-bleu.jpg"];

const Formats = () => {
  const { t } = useLang();
  return (
    <section className="border-y border-[#232733] bg-[#111318] px-6 lg:px-12 py-20 lg:py-28" data-testid="formats-section">
      <SectionHead index="02" overline={t.formats.overline} title={t.formats.title} desc={t.formats.desc} />
      <Reveal delay={0.1} className="mt-14">
        <div className="border border-[#232733] overflow-hidden" data-testid="formats-image">
          <img src="/assets/formats-banner.jpg" alt={t.formats.title} loading="lazy" decoding="async" className="w-full h-64 lg:h-80 object-cover object-bottom" />
        </div>
      </Reveal>
      <div className="grid md:grid-cols-3 gap-px bg-[#232733] border border-[#232733] border-t-0">
        {t.formats.items.map((f, i) => (
          <Reveal key={i} delay={i * 0.1} className="bg-[#0A0B0E]">
            <div className="h-full group hover:bg-[#1A1D24] transition-colors" data-testid={`format-card-${i}`}>
              <div className="h-56 overflow-hidden border-b border-[#232733]">
                <img
                  src={FORMAT_IMGS[i]}
                  alt={f.title}
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-contain bg-[#f4f4f3] transition-transform duration-700 group-hover:scale-105"
                  data-testid={`format-img-${i}`}
                />
              </div>
              <div className="p-8">
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FF4D00]">{f.tag}</span>
              <h3 className="font-display text-xl font-medium tracking-tight text-white mt-4">{f.title}</h3>
              <p className="text-sm text-[#A0AABF] mt-3 leading-relaxed">{f.desc}</p>
              <div className="flex flex-wrap gap-2 mt-5">
                {f.specs.map((s, j) => (
                  <span key={j} className="font-mono text-[10px] uppercase tracking-[0.15em] text-[#4D8BFF] border border-[#232733] px-3 py-1.5">
                    {s}
                  </span>
                ))}
              </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-24" data-testid="anatomy-section">
        <SectionHead index="03" overline={t.anatomy.overline} title={t.anatomy.title} desc={t.anatomy.desc} />
        <div className="grid lg:grid-cols-[1.2fr_1fr] gap-px bg-[#232733] border border-[#232733] mt-14">
          <Reveal className="bg-[#0A0B0E]">
            <figure className="p-4 sm:p-8 h-full flex flex-col">
              <img src="/assets/plan-preforme.png" alt={t.anatomy.planCaption} loading="lazy" decoding="async" className="w-full object-contain flex-1" data-testid="anatomy-plan" />
              <figcaption className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#647087] mt-4 text-center">{t.anatomy.planCaption}</figcaption>
            </figure>
          </Reveal>
          <div className="bg-[#0A0B0E]">
            {t.anatomy.callouts.map((c, i) => (
              <Reveal key={i} delay={i * 0.08}>
                <div className="flex gap-5 px-8 py-7 border-b border-[#232733] last:border-b-0 group hover:bg-[#1A1D24] transition-colors" data-testid={`anatomy-callout-${i}`}>
                  <span className="font-display text-3xl font-extrabold tracking-tighter text-[#0055FF]">{c.n}</span>
                  <div>
                    <div className="font-display text-lg font-medium tracking-tight text-white">{c.title}</div>
                    <p className="text-sm text-[#A0AABF] mt-1.5 leading-relaxed">{c.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-[#232733] border border-[#232733] border-t-0">
          {t.anatomy.chips.map((c, i) => (
            <Reveal key={i} delay={i * 0.06} className="bg-[#0A0B0E]">
              <div className="p-6 text-center group hover:bg-[#1A1D24] transition-colors">
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#647087]">{c.k}</div>
                <div className="font-display text-lg font-medium text-white mt-3 group-hover:text-[#4D8BFF] transition-colors">{c.v}</div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Formats;
